import { Image, TextSize, Weight } from 'components'

import { Button } from '../../components/buttons/button/index'
import ChallengeIdeasImage from 'assets/about/challenge-ideas.svg?react'
import LastingValueImage from 'assets/about/lasting-value.svg?react'
import TrustBuildingImage from 'assets/about/trust-building.svg?react'
import styled from 'styled-components'

export const SplashContentWrapper = styled.div`
  width: 100%;
  margin-top: 170px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  h1 {
    margin: 0;
    font-size: ${TextSize.h4};
    font-weight: ${Weight.Bold};
    line-height: 110%;
    letter-spacing: -0.8px;
    max-width: 623px;
  }
  span {
    font-size: ${TextSize.small};
    line-height: 130%;
    max-width: 352px;
    opacity: 0.6;
  }
`

export const AboutWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Small`
    margin: 0 40px;
    width: auto;
    margin-bottom: 60px;
  `}

  gap: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const AboutContainer = styled.div`
  width: fill-available;
  margin: 0 auto;
  padding: 0 85px;
  max-width: 825px;
  ${({ theme }) => theme.mediaWidth.Small`
    padding: unset;
    max-width: 680px;
  `}
`

export const ContentContainer = styled(AboutContainer)`
  margin-bottom: 60px;
`
export const FooterCTAContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.investmentBackground};
`

export const AboutInformationWrapper = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: row;
  gap: 56px;
  ${({ theme }) => theme.mediaWidth.Small`
    flex-wrap: wrap;
    height: auto;
`}
`

export const InformationcardWrapper = styled.div`
  width: 226px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${({ theme }) => theme.mediaWidth.Small`
    flex-basis: 100%;
    flex-grow: 0;
  `}
`

export const CardImageContainer = styled.div`
  height: 100px;
`

export const CardTitle = styled.span`
  height: 55px;
  font-size: ${TextSize.two};
  font-weight: ${Weight.Medium};
  line-height: 27.158px;
`

export const CardDescription = styled.span`
  height: 96px;
  ${({ theme }) => theme.mediaWidth.Small`
    height: auto;
  `}
  opacity: 0.6;
  font-size: ${TextSize.small};
  line-height: 130%;
`

//styled svg images
export const ChallengeIdeas = styled(ChallengeIdeasImage)`
  path,
  rect {
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const LastingValue = styled(LastingValueImage)`
  path {
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const TrustBuilding = styled(TrustBuildingImage)`
  circle,
  path,
  rect {
    stroke: ${({ theme }) => theme.primaryFontColor};
  }
`

export const GetStartedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  width: 100%;
  padding-bottom: 0px;
  padding-top: 80px;
  ${({ theme }) => theme.mediaWidth.Small`
    margin: 0 40px;
    width: auto;
    padding-top: unset;
    margin-bottom: 30px;
  `}
`

export const GetStartedTitle = styled.span`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.2px;
`

export const GetStartedButton = styled(Button)`
  width: 152px;
  height: 40px;
`
export const GetStartedDescription = styled.span`
  font-size: ${TextSize.small};
  width: 296px;
  ${({ theme }) => theme.mediaWidth.Small`  
    width: auto;
  `}
`

export const FooterColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  ${({ theme }) => theme.mediaWidth.Small`  
    flex-direction: column-reverse;
    gap: 30px;
  `}
`

export const FooterImageContainer = styled.div`
  position: relative;
  ${({ theme }) => theme.mediaWidth.Small`  
    position: unset;
    bottom: unset;
    right: unset;
    margin: 30px 40px;
  `}
  bottom: 0;
  right: 0;
`

export const FooterImage = styled(Image)`
  position: absolute;
  max-width: 383px;
  max-height: 241px;
  width: 100%;
  right: 0;
  bottom: 0px;
  ${({ theme }) => theme.mediaWidth.Small`  
    max-width: auto;
    max-height: auto;
    position: unset;
    bottom: unset;
    right: unset;
    display: flex;
    margin: 0 auto;
  `}
`
